import React from 'react'

import { AlignItems, Box, Display } from '@gousto-internal/citrus-react'

import type { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { RecipeAttributePill } from '../../RecipeAttributePill/RecipeAttributePill'
import { formatRatingText, formatKcalText, formatCookingTimeText } from './formatters'

type RecipeQuickStatsProps = {
  prepTime?: MenuRecipe['prep_time']
  rating?: MenuRecipe['rating'] | null
  kcalPerPortion?: MenuRecipe['nutritional_information']['per_portion']['energy_kcal'] | null
}

export const RecipeQuickStats = ({ prepTime, rating, kcalPerPortion }: RecipeQuickStatsProps) => {
  if (!kcalPerPortion && !prepTime && !rating) {
    return null
  }

  return (
    <Box
      alignItems={AlignItems.FlexStart}
      wrap
      data-testid="RecipeQuickStats"
      display={Display.Flex}
    >
      {rating && rating.count > 0 && (
        <RecipeAttributePill icon="rate_full" text={formatRatingText(rating)} />
      )}

      {kcalPerPortion && (
        <RecipeAttributePill icon="calories" text={formatKcalText(kcalPerPortion)} />
      )}

      {prepTime && <RecipeAttributePill icon="time" text={formatCookingTimeText(prepTime)} />}
    </Box>
  )
}
